import { connect } from "react-redux";
import PhonePreview from "../../../../shared/components/phone-preview"

const PreviewFaq = (props) => {
   const { faqs } = props;
   return (
      <div className="ice-breaker-preview-wrapper">
         <PhonePreview>
            <div className="ice-breaker-preview">
               {faqs.map((faq, index) => (
                  <div key={index} className="ice-breaker-preview__item">
                     <span>{faq.name}</span>
                  </div>
               ))}
            </div>
         </PhonePreview>
      </div>
   )
}

const mapStateToProps = (state) => {
   const { faq } = state;
   const { items } = faq.faqs;

   return {
      faqs: items
   };
};

export default connect(mapStateToProps, {})(PreviewFaq);